var cio_datamodel = require("cio-datamodel");
var IpcImages = require('./ipcImages/index.js');

var IpcImageHelper = {};

IpcImageHelper.getDimensionImage = function(data) {
    var image = '';

    switch(data.constructor) {
        case cio_datamodel.IpcDataModel.SoicSopData:
            image = IpcImages.soic.dimension;
        break;

        case cio_datamodel.IpcDataModel.CfpData:
            image = IpcImages.cfp.dimension;
        break;

        case cio_datamodel.IpcDataModel.SodData:
            image = IpcImages.sod.dimension;
        break;

        case cio_datamodel.IpcDataModel.QfpData:
            image = IpcImages.qfp.dimension;
        break;

        case cio_datamodel.IpcDataModel.CqfpData:
            image = IpcImages.cqfp.dimension;
        break;

        case cio_datamodel.IpcDataModel.QfnData:
            image = IpcImages.qfn.dimension;
        break;

        case cio_datamodel.IpcDataModel.Sot23Data:
            image = IpcImages.sot23.dimension;
        break;

        case cio_datamodel.IpcDataModel.SotflData:
            image = IpcImages.sotfl.dimension;
        break;

        case cio_datamodel.IpcDataModel.Sot223Data:
            image = IpcImages.sot223.dimension;
        break;

        case cio_datamodel.IpcDataModel.Sot143Data:
            image = IpcImages.sot143.dimension;
        break;

        case cio_datamodel.IpcDataModel.ToDpakData:
            image = IpcImages.dpak.dimension;
        break;

        case cio_datamodel.IpcDataModel.ChipData:
            image = IpcImages.chip.dimension;
        break;

        case cio_datamodel.IpcDataModel.MoldedBodyData:
            image = IpcImages.moldedBody.dimension;
        break;

        case cio_datamodel.IpcDataModel.SodflData:
            image = IpcImages.sodfl.dimension;
        break;

        case cio_datamodel.IpcDataModel.Dfn2Data:
            image = IpcImages.dfn2.dimension;
        break;

        case cio_datamodel.IpcDataModel.Dfn3Data:
            image = IpcImages.dfn3.dimension;
        break;

        case cio_datamodel.IpcDataModel.Dfn4Data:
            image = IpcImages.dfn4.dimension;
        break;

        case cio_datamodel.IpcDataModel.AluminumElectrolyticData:
            image = IpcImages.ecap.dimension;
        break;

        case cio_datamodel.IpcDataModel.CrystalData:
            image = IpcImages.crystal.dimension;
        break;

        case cio_datamodel.IpcDataModel.BgaData:
            image = IpcImages.bga.dimension;
        break;

        case cio_datamodel.IpcDataModel.MelfData:
            image = IpcImages.melf.dimension;
        break;

        case cio_datamodel.IpcDataModel.ChipArrayTwoSideFlatConcaveData:
            image = IpcImages.chipArray2FlatConcave.dimension;
        break;

        case cio_datamodel.IpcDataModel.ChipArrayFourSideFlatConcaveData:
            image = IpcImages.chipArray4FlatConcave.dimension;
        break;

        case cio_datamodel.IpcDataModel.ChipArrayTwoSideConvexData:
            image = IpcImages.chipArray2Convex.dimension;
        break;

        case cio_datamodel.IpcDataModel.PlccData:
            image = IpcImages.plcc.dimension;
        break;

        case cio_datamodel.IpcDataModel.OscillatorCornerConcaveData:
            image = IpcImages.oscCornerConcave.dimension;
        break;

        case cio_datamodel.IpcDataModel.OscillatorLBendData:
            image = IpcImages.oscLBend.dimension;
        break;

        case cio_datamodel.IpcDataModel.OscillatorJLeadData:
            image = IpcImages.oscJLead.dimension;
        break;

        case cio_datamodel.IpcDataModel.SojData:
            image = IpcImages.soj.dimension;
        break;

        case cio_datamodel.IpcDataModel.AxialData:
            image = IpcImages.axial.dimension;
        break;

        case cio_datamodel.IpcDataModel.DipData:
            image = IpcImages.dip.dimension;
        break;

        case cio_datamodel.IpcDataModel.HeaderStraightData:
            image = IpcImages.headerStraight.dimension;
        break;

        case cio_datamodel.IpcDataModel.HeaderRightAngleData:
            image = IpcImages.headerRightAngle.dimension;
        break;

        case cio_datamodel.IpcDataModel.HeaderStraightSocketData:
            image = IpcImages.headerStraightSocket.dimension;
        break;

        case cio_datamodel.IpcDataModel.HeaderRightAngleSocketData:
            image = IpcImages.headerRightAngleSocket.dimension;
        break;

        case cio_datamodel.IpcDataModel.SonData:
            image = IpcImages.son.dimension;
        break;

        case cio_datamodel.IpcDataModel.RadialRoundData:
            image = IpcImages.radialRound.dimension;
        break;

        case cio_datamodel.IpcDataModel.RadialLedRoundData:
            image = IpcImages.radialLedRound.dimension;
        break;

        case cio_datamodel.IpcDataModel.CrystalHC49Data:
            image = IpcImages.crystalHC49.dimension;
        break;

        case cio_datamodel.IpcDataModel.FemaleStandoffSpacerData:
            image = IpcImages.femaleStandoffSpacerData.dimension;
        break;

        case cio_datamodel.IpcDataModel.MaleFemaleStandoffSpacerData:
            image = IpcImages.maleFemaleStandoffSpacerData.dimension;
        break;

        case cio_datamodel.IpcDataModel.SnapLockData:
            image = IpcImages.SnapLockData.dimension;
        break;

        case cio_datamodel.IpcDataModel.ChipLedData:
            image = IpcImages.ChipLed.dimension;
        break;
    }

    return global.FULLDEPLOYMENTPATH + image;
};

module.exports = IpcImageHelper;
